export enum ResourceType {
  Photo = 'PHOTO',
  Video = 'VIDEO',
}
